export default "__VITE_ASSET__BMx7GSt6__"